import { render, staticRenderFns } from "./CompanyDetailPage.vue?vue&type=template&id=2db1f5f1&scoped=true&lang=pug&"
import script from "./CompanyDetailPage.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db1f5f1",
  null
  
)

export default component.exports